import { render, staticRenderFns } from "./LiveDetailsShare.vue?vue&type=template&id=5c4e8f23"
import script from "./LiveDetailsShare.vue?vue&type=script&lang=js"
export * from "./LiveDetailsShare.vue?vue&type=script&lang=js"
import style0 from "./LiveDetailsShare.vue?vue&type=style&index=0&id=5c4e8f23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports